import { CommonResponse, EmployeeCodeRequest } from "@gtpl/shared-models/masters";
import connection from "./connection";
import axios from "axios";
import { EmployeeWeekOffUploadsModelDtoReq } from "libs/shared-models/hrms/src/lib/employee-week-off-uploads/employee-week-off-uploads-dto";
import { EmployeeWeekOffUploadsResponseModel } from "libs/shared-models/hrms/src/lib/employee-week-off-uploads/employee-week-off-uploads-response-model";

export class EmployeeWeekOffUploadsServices{
  
    URL = connection.DEPLOY_URL + '/employee-week-off-uploads';

    async EmployeeWeekOffUploadsExcel(req:EmployeeWeekOffUploadsModelDtoReq): Promise<EmployeeWeekOffUploadsResponseModel> {
        return await axios.post(this.URL + '/EmployeeWeekOffUploadsExcel',req)
            .then(res => {
                return res.data
            })
    }

    async getEmployeeWeekOffUploads(): Promise<EmployeeWeekOffUploadsResponseModel> {
        return await axios.post(this.URL + "/getEmployeeWeekOffUploads")
        .then(res => {
            return res.data
          })
    }
    async getWeekOffByEmpCode(req:EmployeeCodeRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + "/getWeekOffByEmpCode",req)
        .then(res => {
            return res.data
          })
    }
}